import {axios} from "../../helpers/axios";
import { PROCESS_URL } from "../process/processConstants";

export const api_get_process_list_url = async (page,limit,qn,qs) => {
    return axios.get(PROCESS_URL, { params: {page,limit,qn,qs}});
};

export const api_create_process_url = async (data) => {
    return axios.post(PROCESS_URL, data);
};

export const api_update_process_url = async (process_id,updated_data) => {
    return axios.put(PROCESS_URL + "/" + process_id,updated_data);
};

export const api_activate_deactivate_process_url = async (process_id,updated_data) => {
    return axios.patch(PROCESS_URL + "/" + process_id + "/" + updated_data);
};

export const api_get_process_details_url = async (process_id) => {
    return axios.get(PROCESS_URL + "/" + process_id);
};